import { Facility } from 'sletat-api-services/lib/sletat/models/initial-state/page-models/hotel';

export enum HotelBasicFacilities {
    WiFi = 94,
    WiFiInRoom = 130,
    WiFiInLobby = 131,
    BeachWiFi = 132,
    WiFiOnAllArea = 133,
    Transfer = 31,
    ChildrensPool = 142,
    ChildrenWaterSlides = 139,
    ChildrenPlayingRoom = 79,
    ChildrenMenu = 143,
    ChildrenPlayground = 85,
    DoctorsOffice = 124,
    Safe = 20
}

export enum HotelBasicFacilityGroups {
    Internet = 1,
    BeachLine = 6,
    ChildrenServices = 18,
    Transportation = 11,
    Health = 15,
    RoomsAmenities = 8,
    CheckInOutIimes = 19,
}

export enum PopularityLabel {
    NotPopular = 0,
    Popular = 1,
    ExtremelyPopular = 2
}

export interface FacilityWithGroupId extends Facility {
    groupId: number;
    secondName: string;
}

export interface MappedFacilitiesIdsByGroupId {
    [key: number]: Array<number>;
}
